import styles from './styles.module.css'
import React from 'react'

export const ChatThinking = () => (
  <div className={styles.dots} role="status" aria-label="Thinking…" dir="ltr">
    <span className={styles.thinkingLabel} aria-hidden="true">
      Thinking
    </span>
    <i aria-hidden="true" />
    <i aria-hidden="true" />
    <i aria-hidden="true" />
  </div>
)

export const ChatListeningDots = () => (
  <span className={styles.dots} aria-hidden="true">
    <i />
    <i />
    <i />
  </span>
)
